import { Configuration, RedirectRequest } from "@azure/msal-browser"

/**
 * MSAL matches knownAuthorities against an authority's host only, while the
 * environment variable holds a comma-separated list of full authority URLs.
 * Both have to be reduced to bare hosts or no entry can ever match, which
 * leaves custom B2C domains untrusted and makes acquireTokenSilent reject
 * cached accounts with authority_mismatch.
 */
const knownAuthorityHosts = Array.from(
  new Set(
    (process.env.GATSBY_APP_AAD_B2C_KNOWN_AUTHORITIES || "")
      .split(",")
      .map(entry => entry.trim())
      .filter(Boolean)
      .map(entry => {
        try {
          return new URL(entry).host
        } catch {
          return entry
        }
      })
  )
)

/**
 * Config object to be passed to Msal on creation
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.GATSBY_APP_AAD_APPLICATION_ID || "",
    authority:
      process.env.GATSBY_APP_AAD_B2C_INSTANCE +
      process.env.GATSBY_APP_AAD_B2C_TENTANT +
      "/" +
      process.env.GATSBY_APP_AAD_B2C_SIGNINGPOLICY,
    knownAuthorities: knownAuthorityHosts,
    redirectUri: process.env.GATSBY_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.GATSBY_APP_POST_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
}

let b2cScopes = ""

if (
  process.env.GATSBY_APP_AAD_B2C_SCOPES_ACCESS_USER_DATA !== undefined &&
  process.env.GATSBY_APP_AAD_B2C_SCOPES_ACCESS_USER_DATA !== null
)
  b2cScopes = process.env.GATSBY_APP_AAD_B2C_SCOPES_ACCESS_USER_DATA

export const loginRequest: RedirectRequest = {
  scopes: [b2cScopes],
}
